export default {
    props: {
        aggregates: Array,
        attributes: Object, 
        columns: Array, 
        command: String | Array, 
        editable: Function,
        editor: Function, 
        encoded: Boolean, 
        field: String, 
        filterable: Boolean, 
        filterableCellDataSource: {
            type: Object,
            kComposite: 'filterable.cell.dataSource'
        }, 
        filterableCellDataTextField: {
            type: String,
            kComposite: 'filterable.cell.dataTextField'
        }, 
        filterableCellDelay: {
            type: Number,
            kComposite: 'filterable.cell.delay'
        }, 
        filterableCellInputWidth: {
            type: Number,
            kComposite: 'filterable.cell.inputWidth'
        }, 
        filterableCellSuggestionOperator: {
            type: String,
            kComposite: 'filterable.cell.suggestionOperator'
        }, 
        filterableCellMinLength: {
            type: Number,
            kComposite: 'filterable.cell.minLength'
        }, 
        filterableCellEnabled: {
            type: Boolean,
            kComposite: 'filterable.cell.enabled'
        }, 
        filterableCellOperator: {
            type: String,
            kComposite: 'filterable.cell.operator'
        }, 
        filterableCellShowOperators: {
            type: Boolean,
            kComposite: 'filterable.cell.showOperators'
        }, 
        filterableCellTemplate: {
            type: Function,
            kComposite: 'filterable.cell.template'
        }, 
        filterableMulti: {
            type: Boolean,
            kComposite: 'filterable.multi'
        }, 
        filterableDataSource: {
            type: Object | Array,
            kComposite: 'filterable.dataSource'
        }, 
        filterableCheckAll: {
            type: Boolean,
            kComposite: 'filterable.checkAll'
        }, 
        filterableItemTemplate: {
            type: Function,
            kComposite: 'filterable.itemTemplate'
        }, 
        filterableOperators: {
            type: Object,
            kComposite: 'filterable.operators'
        }, 
        filterableSearch: {
            type: Boolean,
            kComposite: 'filterable.search'
        }, 
        filterableIgnoreCase: {
            type: Boolean,
            kComposite: 'filterable.ignoreCase'
        }, 
        filterableUi: {
            type: String | Function,
            kComposite: 'filterable.ui'
        }, 
        footerAttributes: {
            type: Object,
            kComposite: 'footerAttributes'
        }, 
        footerTemplate: {
            type: String | Function,
            kComposite: 'footerTemplate'
        }, 
        format: String, 
        groupable: Boolean, 
        groupHeaderTemplate: {
            type: String | Function,
            kComposite: 'groupHeaderTemplate'
        }, 
        groupFooterTemplate: {
            type: String | Function,
            kComposite: 'groupFooterTemplate'
        }, 
        headerAttributes: {
            type: Object,
            kComposite: 'headerAttributes'
        }, 
        headerTemplate: {
            type: String | Function,
            kComposite: 'headerTemplate'
        }, 
        hidden: {
            type: Boolean,
            kComposite: 'hidden'
        }, 
        locked: Boolean, 
        lockable: Boolean, 
        minResizableWidth: {
            type: Number,
            kComposite: 'minResizableWidth'
        }, 
        minScreenWidth: {
            type: Number,
            kComposite: 'minScreenWidth'
        }, 
        selectable: Boolean, 
        sortable: Boolean, 
        sortableCompare: {
            type: Function,
            kComposite: 'sortable.compare'
        }, 
        sortableInitialDirection: {
            type: String,
            kComposite: 'sortable.initialDirection'
        }, 
        template: String | Function, 
        title: String, 
        width: String | Number, 
        values: Array, 
        menu: Boolean
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridColumn/Columns.js